import request from '@/utils/request'

const api = {
  newsList: '/news/news/listJson',
  newDetail: '/news/news/get',
  newDel: '/news/news/remove',
  newsEdit: '/news/news/save',
  newsStatusChange: '/news/news/setStatus'
}

export default api

export function getNewsList (parameter) {
  return request({
    url: api.newsList,
    method: 'get',
    params: parameter
  })
}

export function getNewDetail (parameter) {
  return request({
    url: api.newDetail,
    method: 'get',
    params: parameter
  })
}

export function newEdit (data) {
    return request({
      url: api.newsEdit,
      method: 'post',
      data: data
    })
  }

export function newDel (parameter) {
  return request({
    url: api.newDel,
    method: 'get',
    params: parameter
  })
}
